var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFooterLogo = function SvgFooterLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1737 726",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 54.031C0 32.28 19.917 16.293 41.145 20.75l477.228 100.896c36.166 7.6 36.166 58.966 0 66.566L41.145 288.845C19.917 293.301 0 277.314 0 255.563V54.031Zm0 416.69c0-21.751 19.917-37.737 41.145-33.282l477.228 100.896c36.166 7.6 36.166 58.966 0 66.566L41.145 705.536C19.917 709.991 0 694.005 0 672.253V470.721Zm634.994 25.421c21.228 4.455 41.145-11.793 41.145-33.283V263.687c0-21.752-19.917-37.738-41.145-33.283L159.338 329.99c-36.165 7.6-36.165 59.228 0 66.566l475.656 99.586Z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M783.402 581V144.636h314.488v95.455H901.868v75H1081.7v95.454H901.868v75h195.172V581H783.402ZM1534.2 144.636V581h-98.86l-157.67-229.261h-2.56V581h-118.47V144.636h100.57l155.12 228.409h3.41V144.636h118.46Zm174.5 0V581h-118.46V144.636h118.46Z",
    fill: "#000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 35.548,
    y1: 297.998,
    x2: 575.902,
    y2: 561.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BDA9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3492CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7856FF"
  })))));
};
export default SvgFooterLogo;